import React from "react";
import PropTypes from "prop-types";

import styles from "./CookieConsent.scss";

function CookieIcon({ children, ...otherProps }) {
  return (
    <div className={styles["icon-container"]} {...otherProps}>
      <div className={styles.icon}>{children}</div>
    </div>
  );
}

CookieIcon.propTypes = {
  children: PropTypes.node.isRequired,
};

CookieIcon.displayName = "CookieConsent.Option.Icon";

export default CookieIcon;
